import React, { useEffect, useCallback, useMemo } from "react";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import { useOpenComponent } from "hooks/useOpenComponent";

import { useDispatch, useSelector } from "react-redux";

import AddIcon from "@mui/icons-material/Add";
import { columns } from "./columns";
import RegularButton from "components/CustomButtons/Button";
import { Home } from "@mui/icons-material";
import { useSearch } from "hooks/useSearch";
import { ModalV2 } from "components/Modal/ModalV2";

import { ROUTES_PHRASE } from "./config";
import { RouteForm } from "./RoutesForm";
import {
  fetchRoutes,
  newRoute,
  clearRoutes,
  handleRoutesBuildingsInputsAction,
} from "redux/actions/buildings/routes/routesActions";

export const RoutesPage = () => {
  const dispatch = useDispatch();
  const { isOpen, handleIsOpen } = useOpenComponent();

  const { setSnackbar, clearSearch } = useSearch();
  const { stationsList } = useSelector(state => state.companies);
  const { isLoading } = useSelector(state => state.search);
  const { routes, station, isAddMode, deleteMode } = useSelector(state => state.routesBuildings);

  const getRoutes = useCallback(
    stationID => {
      dispatch(fetchRoutes(stationID));
    },
    [dispatch]
  );

  const routesMemo = useMemo(
    () =>
      routes.map(route => {
        const newStation = stationsList?.find(
          station => station.id === route.idStation
        );

        return {
          ...route,
          station: newStation.name,
          employee: route.employee?.name,
          idEmployee: route.employee?.id,
          modal: handleIsOpen
        };
      }),
    [routes]
  );

  const handleSubmit = useCallback(() => {
    if (station.length < 1) {
      setSnackbar(ROUTES_PHRASE.search.messages.noStations);
      return;
    }
    const stationID = station.id;
    getRoutes(stationID);
  }, [station, setSnackbar]);

  const submitMemoized = useCallback((e) => {
    e.preventDefault();
    handleSubmit();
  }, [handleSubmit]);

  const handleOpenAdd = () => {
    dispatch(newRoute());
    handleIsOpen();
  };

  useEffect(() => {
    clearSearch();
    dispatch(clearRoutes());
  }, [clearSearch]);

  return (
    <React.Fragment>
      <CardTable
        data={routesMemo}
        columns={columns}
        loading={isLoading}
        title={ROUTES_PHRASE.page.table.title}
        icon={<Home />}
        hasHeader
        blockBtn
        hasControl
        controls={
          true && (
            <RegularButton
              size="sm"
              round
              justIcon
              color="info"
              style={{ margin: 10 }}
              onClick={handleOpenAdd}
            >
              <AddIcon style={{ margin: 0 }} />
            </RegularButton>
          )
        }
        tableContent={
          <TableInputs
            reducer="routesBuildings"
            stations
            dispatchAction={handleRoutesBuildingsInputsAction}
            submitAction={submitMemoized}
          />
        }
      />
      <ModalV2
        open={isOpen}
        onClose={handleIsOpen}
        toRight
        title={isAddMode
          ? ROUTES_PHRASE.modal.titles.add
          : deleteMode
            ? ROUTES_PHRASE.modal.titles.delete
            : ROUTES_PHRASE.modal.titles.edit}
      >
        {
          <RouteForm
            handleClose={handleIsOpen}
            stationSelected={station}
          />
        }
      </ModalV2>
    </React.Fragment>
  );
};
